module.exports = __webpack_public_path__ + "static/media/meeting2.bc8e9499.png";